import {memo} from 'react';
import cx from 'classnames';
import cStyles from '@/skeleton/common.less';
import styles from './index.less';

export default memo(() => {
    return (
        <div className={cx(cStyles.skeleton, styles.skeleton)}>
            <div className={styles.search}></div>
            <div className={styles.king}>
                <div className={styles.item}>
                    <div className={styles.image} />
                </div>
                <div className={styles.item}>
                    <div className={styles.image} />
                </div>
                <div className={styles.item}>
                    <div className={styles.image} />
                </div>
            </div>

            <div className={styles.banner}></div>
            <div className={styles.activity}>
                <div className={styles.header}>
                    <div className={styles.leftItem}></div>
                    <div className={styles.rightItem}>
                        <div className={styles.title}></div>
                        <div className={styles.title}></div>
                    </div>
                </div>
                <div className={styles.contentItem} />
                <div className={styles.contentItem} />
                <div className={styles.lastContentItem} />
            </div>
            <div className={styles.activity}>
                <div className={styles.header}>
                    <div className={styles.leftItem}></div>
                    <div className={styles.rightItem}>
                        <div className={styles.title}></div>
                        <div className={styles.title}></div>
                    </div>
                </div>
                <div className={styles.contentItem} />
                <div className={styles.contentItem} />
                <div className={styles.lastContentItem} />
            </div>
            <div className={styles.activity}>
                <div className={styles.header}>
                    <div className={styles.leftItem}></div>
                    <div className={styles.rightItem}>
                        <div className={styles.title}></div>
                        <div className={styles.title}></div>
                    </div>
                </div>
                <div className={styles.contentItem} />
                <div className={styles.contentItem} />
                <div className={styles.lastContentItem} />
            </div>
        </div>
    );
});
